<div
  class="stats flex h-auto w-full flex-col justify-between bg-white p-[15px] text-blue-950 shadow-[0_2px_6px_rgba(0,0,0,0.1)]"
>
  <div class="flex min-h-8 items-center justify-between">
    <h2 class="m-0 font-sans text-base font-normal [text-wrap:auto]">
      {{ data().title }}
    </h2>
  </div>
  <div
    class="relative flex min-h-[80px] items-center justify-center overflow-visible pt-[7px] text-center text-2xl font-normal"
    [class.pointer-events-none]="loading() || data().records === 0"
    #modalContent
  >
    <ngx-gauge
      class="!flex justify-center [&>.reading-block]:pb-2 [&>.reading-label]:max-w-24 [&>.reading-label]:whitespace-normal [&>.reading-label]:pb-2 [&>.reading-label]:leading-[1.2]"
      [ngClass]="{
        'opacity-20 blur-[0.1rem]': loading(),
        'blur-[0.1rem]': !loading() && data().records === 0,
      }"
      [value]="data().value"
      [min]="data().minValue"
      [max]="data().maxValue"
      [type]="'arch'"
      [cap]="'butt'"
      [thick]="12"
      [margin]="20"
      [thresholds]="data().thresholds"
      [label]="data().numberLabel"
      [markers]="data().markers"
      [attr.aria-label]="data().title + ': ' + data().value + ' out of ' + data().maxValue"
      [appTooltip]="tooltipTemplate"
      role="img"
    />

    @if (loading()) {
      <div
        class="absolute flex flex-col items-center justify-center"
        role="status"
        aria-label="Loading chart data"
      >
        <mat-spinner [diameter]="75" aria-hidden="true"></mat-spinner>
      </div>
    } @else if (data().records === 0) {
      <div
        class="absolute inset-0 flex flex-col items-center justify-center gap-1.5 bg-white"
        role="status"
      >
        <span class="material-icons-outlined text-[2rem] text-gray-300" aria-hidden="true"
          >bar_chart</span
        >
        <span class="text-sm font-semibold text-gray-400"
          >No data available</span
        >
        <span class="text-xs text-gray-300"
          >Nothing to display for this period</span
        >
      </div>
    }
  </div>

  <div></div>
  <!-- Helps to center the gauge -->
</div>

<ng-template #tooltipTemplate>
  <div>
    <strong>{{ data().value }}</strong>
  </div>
</ng-template>
